<template>
  <div class="c-panel c-panel--large u-mb">
    <router-link class="c-panel__content"  :to="{ name: 'project', params: { slug: slug }}">
      <div class="c-panel__figure o-cover" :style="{ 'background-image':'url(' + image + ')'}">
      </div>
      <div class="c-panel__body">
        <div class="c-panel__arrow">
          <img src="@/assets/arrow-right-blue.svg" width="42" height="42" alt="Right arrow">
        </div>
        <h4 class="c-panel__heading u-h2">{{ heading }}</h4>
        <div class="u-ff-alt u-italic o-box-off">
          <p>{{ body }}</p>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ProjectActiveCard',
  props: {
    heading: {
      type: String,
      required: true
    },
    body: {
      type: String
    },
    slug: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectActiveCard.vue